import React, { useEffect, useState } from 'react';
import { PeriodosAdapter } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorPeriodos from './selector';

export const SelectorPeriodosContainer = (props: any) => {
	let { addTodos, soloCerrados, año } = props;
	const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [periodos, setPeriodos] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
    getPeriodosDesc();
  },[addTodos, soloCerrados, año])

	const getPeriodosDesc = async () => {
		try {
			if(soloCerrados != undefined && soloCerrados && año != undefined) result = await api.ListarPeriodosEjercicio({Año: año,soloCerrados: true});
			else result = await api.ListarPeriodosDescripciones();
			if(result.data && result.data!=="")
			{
				var periodos = [ ...result.data ] || [];
				if(addTodos != undefined && addTodos) periodos.push({"idTipoPeriodo":-1,"tipoPeriodo":"Todos"});
				setPeriodos(periodos);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorPeriodos {...props} data={periodos}/>
};

export default SelectorPeriodosContainer;